import { Dispatch, SetStateAction } from "react";
import { DepartmentTypes } from "../../../PatientCare/PatientBooking/v1/types";

export type SearchParamsType = {
  filter: {
    status: number | null;
    search: string;
  };
  pageNumber: number;
  pageSize: number;
};

export type MasterTableDataType = {
  name: string;
  id: number;
  status: number;
  clinicId: number;
  createdById: number;
  followUpFee: number;
  tokenPrefix: string;
  consultationFee: number;
  followUpCodeId: number;
  sign: string;
  photo: string;
  ccep: string;
  roomNo: string;
  seal: string;
  ip: string;
  code: string;
  consultationCodeId: number;
  postOfficeUsername: string;
  durationForPatient: number;
  postOfficePassword: string;
  consultationCode: string;
  licenceNumber: string;
  followUpCode: string;
  deptName: string;
  deptId: number;
  color: string;
  isTimeSlot: 0 | 1;
  isLicence: 0 | 1;
  clinicianId: number;
};

export type MasterDataType = {
  icdId: number | null;
  icdCode: string;
  icdClinicId: number;
  icdCreatedByDate: string;
  icdCreatedById: number;
  icdDescription: string;
  icdName: string;
  icdStatus: number;
  icdVersion: string;
};

export type SaveResponseType = {};

export type UploadedListType = {
  icdDescription: string | null;
  icdStatus: number;
  icdVersion: string;
  icdName: string;
  icdCode: string;
  icdId: number;
};

export type ClinicianList = {
  createdDate: string;
  createdByUserId: number;
  clcn_id: number;
  clcn_name: string;
  clcn_clinicId: number;
  clcn_ministry: string;
  clcn_code: string;
  clcn_status: number;
};

export type ConsultationCodeType = {
  cptStatus: number;
  cptDes: string;
  cptName: string;
  cptCode: string;
  cptRate: number;
  cptId: number | string;
  cptgroupId: number;
};

export type DurationListType = {
  value: number;
  label: string;
};

export type DoctorLicenseTpe = {
  id: number | null;
  poId: number | null;
  licensecode: string;
  postofficename: string | null;
  doctorLicenseId: number | null;
};

export const initialLicense: DoctorLicenseTpe = {
  id: 0,
  doctorLicenseId: null,
  licensecode: "",
  poId: 0,
  postofficename: "",
};

export type DoctorMasterDataContextType = {
  licenseList: DoctorLicenseTpe[];
  setLicenseList: Dispatch<SetStateAction<DoctorLicenseTpe[]>>;
  timeSlots: { [key: number]: TimeSlotType };
  setTimeSlots: Dispatch<SetStateAction<{ [key: number]: TimeSlotType }>>;
  isTimeEdit: boolean;
  setIsTimeEdit: Dispatch<SetStateAction<boolean>>;
};

export type MasterFormDataType = {
  code: string;
  clinician: ClinicianList | null;
  consultationCode: ConsultationCodeType | null;
  name: string;
  followUpCode: ConsultationCodeType | null;
  ccep: string;
  consultationFee: number | string | null;
  followUpFee: number | string | null;
  department: DepartmentTypes | null;
  roomNumber: string;
  tokenPrefix: string;
  color: string;
  userName: string;
  password: string;
  duration: DurationListType | null;
  status: number;
  sign: File | null;
  seal: File | null;
  photo: File | null;
};

export type DoctorSaveObjectType = {
  id: number;
  code: string;
  clcn_id: number;
  ccep: string;
  consultationFee: string;
  consultationCodeId: number;
  followUpCodeId: number;
  followUpFee: string;
  dept_id: number;
  status: number;
  photo: string;
  sign: string;
  seal: string;
  postOfficeUsername: string;
  postOfficePassword: string;
  roomNo: string;
  tokenPrefix: string;
  ip: string;
  durationForPatient: number;
  createdDate: string;
  color: string;
};

export type TimeSlotType = {
  id: number;
  endTime: string;
  startTime: string;
  effectiveFrom: string;
  dayId: number;
};

export type TimeSlotSaveType = {
  doctorId: number | null;
  day: { dayId: number; startTime: string; endTime: string }[];
  isAllDaySame: boolean;
  canAllocateForMultiplePatient: boolean;
  status:number
};

export const initialFormData: MasterFormDataType = {
  code: "",
  clinician: null,
  consultationCode: null,
  name: "",
  followUpCode: null,
  ccep: "",
  consultationFee: null,
  followUpFee: null,
  department: null,
  roomNumber: "",
  tokenPrefix: "",
  color: "#000000",
  userName: "",
  password: "",
  duration: {
    value: 6,
    label: "10 Minutes",
  },
  status: 1,
  sign: null,
  seal: null,
  photo: null,
};
